import React from 'react';
import { Platform, View } from 'react-native';
import Button from '@/components/Buttons/Button';
import Text from '@/components/Typography/Text';
import usePendingReferral from '@/hooks/usePendingReferral';
import { useTranslation } from '@/hooks/useTranslation';
import { referralAppUrl } from '@/lib/pendingReferral';

export default function ReferralAppHandoff() {
  const { t } = useTranslation();
  const code = usePendingReferral();
  if (Platform.OS !== 'web' || !code) return null;
  const mobile = typeof navigator !== 'undefined'
    && (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
      || (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1));
  return <View style={{ width: '100%', maxWidth: 560, gap: 10, alignItems: 'center' }}>
    <Text weight="semibold" style={{ textAlign: 'center' }}>{t('auth.signup.referralInvitationSaved')}</Text>
    {mobile && <Button text={t('auth.signup.referralOpenApp')} prependIcon="arrow-up-right-from-square"
      onPress={() => { window.location.href = referralAppUrl(code); }} />}
    <Text size="s" color="secondary" style={{ textAlign: 'center', lineHeight: 21 }}>
      {t(mobile ? 'auth.signup.referralInstallHelp' : 'auth.signup.referralDesktopHelp')}
    </Text>
  </View>;
}
